// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/skillTrain.css
// module id = 2711
// module chunks = 2